import React from 'react'
import { FrontendBaseConfig } from '@config/base'
import { BlogInterface } from '@components/seo/src/Blog/Blog'
import { complexTextValueToString } from '@components/seo/src/util'
import NextHead from 'next/head'
export interface BlogSchemaProps {
    asPath: string
    base: FrontendBaseConfig
    title: string
    blogInfo: BlogInterface
}

export const BlogArticleSchema = ({
    asPath,
    base,
    title,
    blogInfo
}: BlogSchemaProps): JSX.Element => {
    const getImageUrls = (): Array<string> => {
        const mediaUrls = blogInfo.media_gallery
            ? blogInfo.media_gallery.split(';').map((url) => {
                  return base?.url?.mediaBackend?.baseMediaUrl + url
              })
            : []
        return [blogInfo.featured_image, ...mediaUrls]
    }
    const data = {
        '@context': 'https://schema.org',
        '@type': 'BlogPosting',
        mainEntityOfPage: {
            '@type': 'Webpage',
            '@id': base.url.baseUrl + asPath.replace('/', '')
        },
        headline: title,
        description: complexTextValueToString(blogInfo?.short_content),
        image: getImageUrls(),
        datePublished: blogInfo?.publish_time,
        dateModified: blogInfo?.modified_time,
        author: [
            {
                '@type': 'Person',
                name: blogInfo?.author?.name,
                url: blogInfo?.author?.author_url
            }
        ],
        publisher: {
            '@type': 'Organization',
            name: 'Hookah-Shisha',
            url: base?.url?.baseUrl
        }
    }
    return (
        <NextHead>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(data, null, '\t')
                }}
            />
        </NextHead>
    )
}
